import { Check } from "lucide-react";
import { useTranslation } from "react-i18next";

import {
  ToggleGroupInput,
  ToggleGroupInputItem,
} from "@/components/shared/form/toggle-group-input";

type Props = {
  value: boolean;
  onChange: (value: boolean) => void;
};

export const TransferNeededSelect = ({ value, onChange }: Props) => {
  const { t } = useTranslation();

  return (
    <ToggleGroupInput<boolean>
      name="isPaid"
      className="grid grid-cols-2 gap-4"
      onChange={onChange}
    >
      <ToggleGroupInputItem
        value={false}
        className="rounded-lg border text-card-foreground shadow-sm h-9 px-3 cursor-pointer transition-all duration-200 hover:bg-gray-50 hover:border-gray-300 bg-white border-gray-200"
      >
        <div className="flex items-center justify-center gap-3 h-full">
          <div
            className={`w-4 h-4 rounded-full border-2 flex items-center justify-center transition-all duration-200 ${!value ? "bg-black border-black" : "border-gray-400"}`}
          >
            {!value && <Check className="w-3 h-3 text-white" />}
          </div>
          <span className="text-sm font-medium">
            {t("payment_details.status.draft")}
          </span>
        </div>
      </ToggleGroupInputItem>
      <ToggleGroupInputItem
        value={true}
        className="rounded-lg border text-card-foreground shadow-sm h-9 px-3 cursor-pointer transition-all duration-200 bg-white border-gray-300"
      >
        <div className="flex items-center justify-center gap-3 h-full">
          <div
            className={`w-4 h-4 rounded-full border-2 flex items-center justify-center transition-all duration-200 ${value ? "bg-black border-black" : "border-gray-400"}`}
          >
            {value && <Check className="w-3 h-3 text-white" />}
          </div>
          <span className="text-sm font-medium">
            {t("payment_details.status.paid")}
          </span>
        </div>
      </ToggleGroupInputItem>
    </ToggleGroupInput>
  );
};
